import axios from "axios";

export default {
    state: {
        versions: null,
    },
    getters: {
        getVersions(state) {
            return state.versions
        },
    },
    mutations: {
        setVersions(state, data) {
            return state.versions = data
        },
    },
    actions: {
        versionsRequest(context) {
            return axios.get('/api/admin/version/all')
                .then(res => {
                    context.commit('setVersions', res.data)
                })
        },
    }
}